<h1 mat-dialog-title class="text-dark text-xl">Nuovo Accessorio</h1>
<div mat-dialog-content class="w-full">
  <app-accessory-practice-form [data]="data"></app-accessory-practice-form>
</div>
